<template>
    <div>
        <el-card>
             <el-input placeholder="请输入关键字" v-model="searchName" style="width:300px" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
        </el-card>
        <el-card style="margin-top:15px;">
             <el-table
                :data="list"
                style="width: 100%;margin-bottom: 20px;"
                :row-key="getRowKeys"
                border
                ref="treeTable"
                :expand-row-keys="expands"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column
                prop="id"
                label="编号"
                sortable
                width="180">
                </el-table-column>
                <el-table-column
                prop="typeName"
                label="产品名称"
                sortable
                 >
                </el-table-column>
                <el-table-column
                prop="createTime"
                label="日期"
                sortable
                 >
                </el-table-column>
                <el-table-column
                prop="updateTime"
                label="修改时间">
                </el-table-column>
                 <el-table-column
                label="操作">
                    <template  slot-scope="scope">
                        <el-button size='mini' type="primary" @click="addShow(scope.row)">新增</el-button>
                        <el-button size='mini' @click="updShow(scope.row)">修改</el-button>
                        <el-button size='mini' type="danger" @click="del(scope.row)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog 
            :visible.sync="dialogVisible" 
            width="750px"
            @close="closeDialog()"
            :title="currentAddData!=undefined && currentAddData.id>0 ? '修改':'新增'"
            >
                <el-form :model="currentAddData" :rules="rules" ref="currentAddData" label-width="100px">
                    <el-form-item 
                
                     label="上级"
                    >
                          <el-cascader
                            style="width:100%"
                            class="cascader"
                            v-model="currentAddData.parentId"
                            :props="{value:'id',label:'typeName',expandTrigger:'click',checkStrictly:true}"
                            :options="options"
                           ></el-cascader>
                       
                    </el-form-item>
                    <el-form-item 
               
                     label="产品名称"
                    
                    >
                       <el-input v-model="currentAddData.typeName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('currentAddData')">保存</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
 
export default {
    name: 'consultingTypeList',
    props:[],
    data(){
       return {
         list:[],
         options:[],
         defaultList:[],
         dialogVisible:false,
         currentAddData:{
            parentId:0,
            typeName:''
         },
         rules:{
            typeName:[{ required: true, message: '请输入产品名称', trigger: 'blur' }],
            parentId: [{ required: true, message: '请选择上级', trigger: 'change' }]
         },
         searchName:'',
         expands:[],
         getRowKeys(row){
             
            return row.id;
         }
    
       }
    },
    created:function(){
        this.getList();
    },
    methods:{
        getList(){
            let vm = this
            var enums = [{id:'0',typeName:'无上级'}];
            this.axios
            .get('ConsultationTypes/GetConsultationTypeList')
            .then(function({data}){
                vm.list = data.data.list;
                vm.defaultList = data.data.consultationTypes;
                vm.options=enums.concat(data.data.list);
            })
        },
        addShow(obj){
             
            this.currentAddData.parentId=obj.parentId==0?'0':obj.parentId;
            this.dialogVisible=true;
        },
        updShow(obj){
            let newObj = {...obj};
             
            newObj.parentId= newObj.parentId==0?'0':newObj.parentId;
            this.currentAddData=newObj;
            this.dialogVisible=true;
        },
        del(obj){
           debugger
           if(obj.children.length>0){
                this.$confirm('存在子集，删除该项子集会一并删除，是否删除？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                         this.delRow(obj.id);
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                    });

           }else{
            this.delRow(obj.id);
           }
        },
        delRow(id){
            let vm = this;
            this.axios.get(`/ConsultationTypes/del/${id}`).then(function({data}){
                    if(data.result){
                        vm.$message.success('删除成功');
                        vm.getList();
                        
                    }else{
                        vm.$message.error(data.message);
                    }
            })
        },
        closeDialog(){
            this.currentAddData={};
            this.dialogVisible=false;
        },
        submitForm(formName){
            let vm = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                   if(this.currentAddData.typeName==undefined || this.currentAddData.typeName==''){
                        this.$message.error('请填写产品名称');
                        return;
                   }
                  let obj = {...this.currentAddData};
                   
                  if(this.currentAddData.parentId instanceof Array){
                    obj.parentId = this.currentAddData.parentId[this.currentAddData.parentId.length-1];
                  }
                  obj.parentId=parseInt(obj.parentId);
                  if(this.currentAddData.id!=undefined && this.currentAddData.id>0){
                        this.axios.post('/ConsultationTypes/Upd',obj).then(function({data}){
                            if(data.result){
                                vm.$message.success('保存成功');
                                vm.resetForm(formName);
                                vm.dialogVisible=false;
                                vm.getList();
                            
                            }else{
                                vm.$message.error('保存失败');
                            }
                    })
                  }else{
                     this.axios.post('/ConsultationTypes/Add',obj).then(function({data}){
                        if(data.result){
                            vm.$message.success('保存成功');
                            vm.resetForm(formName);
                            vm.dialogVisible=false;
                            vm.getList();
                        
                        }else{
                            vm.$message.error('保存失败');
                        }
                   })
                  }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
          this.currentAddData={};
        },
        getParentKey(key,tree){
            let parentKey;
            for (let i = 0; i < tree.length; i++) {
                const node = tree[i];

                if (node.children) {
                    if (node.children.some((item) => item.id === key)) {
                        parentKey = node.id;
                    } else if (this.getParentKey(key, node.children)) {
                        parentKey = this.getParentKey(key, node.children);
                    }
                }
            }
            return parentKey;
        },
        onSearch(){
          const value=this.searchName;
          const newExpandedKeys = this.defaultList
                        .map((item) => {
                            if (item.typeName.indexOf(value) > -1) {
                            return this.getParentKey(item.id, this.list);
                            }
                            return null;
                        })
                        .filter((item, i, self) => {
                            return item && self.indexOf(item) === i;
                        });
          
         if(newExpandedKeys.length>0 && value!=''){
             var ids = [];
            newExpandedKeys.map(d=>{
                this.getParentId(this.defaultList,d,ids);
                ids.push(d);
            });
            this.expands=ids.map(d=>{
                if(d!=undefined){
                    return d+'';
                }
            })
         }else{
            this.expands=[];
            this.closeExpandRow(this.list,false);
         }
     },
     getParentId(defaultList,parentId,ids){
       let node = defaultList.find(d=>d.id==parentId)
        if(node!=null){
            ids.push(this.getParentId(defaultList,node.parentId,ids));
            return node.id;
        }
        return
     },
     closeExpandRow(data,isExpansion){
        data.forEach((item) => {
            this.$refs.treeTable.toggleRowExpansion(item, isExpansion);
            if (item.children.length>0) {
                this.closeExpandRow(item.children, isExpansion);
            }
        });
     }
    }
}
</script>
<style scoped>
.el-input{
    width: 100%;
}
 .cascader >>> .el-input--suffix {
    width: 100%;
 }
</style>


// WEBPACK FOOTER //
// src/components/manage/setting/ConsultingTypeList.vue